export default {
      id: "cookie-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.e72ac2e3.svg#cookie",
      toString: function () {
        return this.url;
      }
    }